/**
 * Runs once when a snippet loads.
 * Normalizes the source and splits it into a character array for O(1) index access.
 */
export function preprocessText(source: string): string[] {
  // Normalize tabs to 4 spaces before splitting — do this once, not per keystroke
  const normalized = source.replace(/\t/g, '    ');
  // Array.from handles Unicode code points correctly (important for Python docstrings)
  return Array.from(normalized);
}

export function buildLineOffsets(chars: string[]): number[] {
  // Returns the starting char index for each line, used to map index -> line
  const offsets: number[] = [0];
  for (let i = 0; i < chars.length; i++) {
    if (chars[i] === '\n') {
      offsets.push(i + 1);
    }
  }
  return offsets;
}

export function splitIntoLines(chars: string[]): string[][] {
  const lines: string[][] = [];
  let current: string[] = [];
  for (const ch of chars) {
    if (ch === '\n') {
      current.push('\n');
      lines.push(current);
      current = [];
    } else {
      current.push(ch);
    }
  }
  if (current.length > 0) {
    lines.push(current);
  }
  return lines;
}
